"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function PostsList() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="flex flex-col gap-[120px]">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col items-start animate-pulse">
            <div className="h-10 w-3/4 bg-muted mb-6" />
            <div className="flex gap-4 mb-5">
              <div className="h-5 w-24 bg-muted" />
              <div className="h-5 w-32 bg-muted" />
            </div>
            <div className="h-4 w-full bg-muted mb-2" />
            <div className="h-4 w-2/3 bg-muted mb-8" />
            <div className="h-4 w-24 bg-muted" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center py-12 text-muted-foreground font-default">
        Stories could not be loaded at this time.
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center py-12 text-muted-foreground font-default">
        No stories have been published yet.
      </div>;
  }
  return <div className="flex flex-col gap-[120px]">
      {posts.map((post, i) => {
      const readingTime = post.customFields?.reading_time || "5";
      const formattedDate = post.date ? new Date(post.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      }) : "Recently";
      return <article key={post.id} data-index={i} className="flex flex-col items-start group/article border-b border-border/30 pb-[120px] last:border-0 last:pb-0">
            <Link to={post.link || "#"} className="block w-full">
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight text-foreground transition-colors duration-400 group-hover/article:text-primary tracking-tight">
                {post.title}
              </h2>
            </Link>
            
            <div className="flex items-center gap-4 mt-6 mb-5">
              <Badge variant="outline" className="font-mono text-[10px] uppercase tracking-widest text-primary border-primary/20 bg-secondary">
                {readingTime} Min Read
              </Badge>
              <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                {formattedDate}
              </span>
            </div>

            {post.excerpt && <div className="font-default text-base md:text-lg leading-relaxed text-muted-foreground line-clamp-2 max-w-2xl" dangerouslySetInnerHTML={{
          __html: post.excerpt
        }} />}

            <Link to={post.link || "#"} className="inline-block mt-8 font-default text-xs uppercase tracking-widest font-medium text-primary relative after:absolute after:bottom-[-6px] after:left-0 after:h-[1px] after:w-full after:origin-bottom-right after:scale-x-0 after:bg-primary after:transition-transform after:duration-400 hover:after:origin-bottom-left hover:after:scale-x-100">
              Read Story
            </Link>
          </article>;
    })}
    </div>;
}
export default function FreshStories() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="253705" id="fresh-stories" className="bg-background text-foreground py-24 md:py-32 lg:py-40">
      <div className="max-w-3xl mx-auto px-6 md:px-8">
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <PostsList />
        </PostsProvider>
      </div>
    </section>;
}